import { cloneDeep, times } from 'lodash';
import createTaskType from '../../createTaskType';
import MultipleMatchingEditor from "./Editor";

const LEX = 'ABCDEFGH';

export default createTaskType({
    id: 'multiple_matching',
    label: 'Multiple Matching',
    skill: 'listening',
    v2: true,
    hasRubric: true,

    createItemsTemplate: () => times(6, i => ({
        index: i,
        is_example: i === 0,
        ...(i === 0 && { rubric_id: '' }),

        audio_id: '',
        drop_zone_location: LEX[i],

        answers: [{
            key_text: '',
            is_correct_answer: true,
            display_order: i + 1,
        }],
    })),
    editor: MultipleMatchingEditor,

    backgroundImages: {
        count: 1,
        configs: [
            { label: 'Background Image' },
        ]
    },

    convertToLocalFormat(task) {
        task.items = task.items.map((item, index) => {
            item.index = index;
            return item;
        })
        return task;
    },

    convertToUploadFormat(task, { isNew }) {
        task = cloneDeep(task);
        task.items = task.items.map(item => {
            delete item.index;
            return item;
        })
        return task;
    },

    getKeys: (item) => {
        const correct_answer = item.answers.find(x => x.is_correct_answer);
        return [correct_answer.key_text];
    }
});